/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import { useNodesFilter } from "./hooks";
import GeneralFilter from "../../Shared/Filter/GeneralFilter";
import { resetDeviceFilters } from "../../../store/filters/Nodes/reducer";
import { Box } from "@mui/material";

interface NodesFilterProps {
  children?: React.ReactNode;
}

export const NodesFilter: React.FC<NodesFilterProps> = ({ children }) => {
  const { dispatch, filters, formControlSx, searchTooltip } = useNodesFilter();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
      <GeneralFilter
        dispatch={dispatch}
        filters={filters}
        formControlSx={formControlSx}
        resetFilters={resetDeviceFilters}
        searchTooltip={searchTooltip}
      />
      {children}
    </Box>
  );
};

export default NodesFilter;
